import axios from "../../utils/axios";

// 列表
export function list() {
    return axios({
        url: "/web/merchants",
        method: "get"
    });
}

// 商家资料查询
export function profiles() {
    return axios({
        url: "/web/merchants/profiles",
        method: "get"
    });
}
//获取商家功能列表
export function businessFunctionList(merchantId, tenantId) {
    return axios({
        url: "/web/merchants/features",
        method: "get",
        params: {
            merchantId,
            tenantId,
            number: 0,
            size: 30
        }
    });
}
